import i18n from "../index";

export const formatNumber = (value: number, options?: Intl.NumberFormatOptions): string => new Intl.NumberFormat(i18n.language || "en", options).format(value);
